import {Table, TableBody, TableCell, TableHead, TableRow} from "@material-ui/core";
import {useEffect, useState} from "react";
import {useGoVehisService} from "../../utils/axios";

function IncorrectOfferList() {

  const goVehisService = useGoVehisService();
  const [logs, setLogs] = useState([]);

  useEffect(() => {
    goVehisService.get("/admin/vehis/logs").then(res => setLogs(res.data));
  }, []);

  return (<div>
    <Table>
      <TableHead>
        <TableRow>
          <TableCell>Data</TableCell>
          <TableCell>ID pojazdu</TableCell>
          <TableCell>Marka</TableCell>
          <TableCell>Model</TableCell>
          <TableCell>Typ nadwozia</TableCell>
          <TableCell>Wiadomość</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {logs.map((log) => (
            <TableRow key={log.id}>
              <TableCell>{log.createDate}</TableCell>
              <TableCell>{log.vehicleId}</TableCell>
              <TableCell>{log.brandName}</TableCell>
              <TableCell>{log.model}</TableCell>
              <TableCell>{log.bodyType}</TableCell>
              <TableCell>{log.message}</TableCell>
            </TableRow>
        ))}
      </TableBody>
    </Table>
  </div>)
}

export default IncorrectOfferList;
